/* eslint-disable no-param-reassign */
import * as network from './network';
import { setPermission, op } from './permission';
import messagePlugin from './message';
import directives from './directives';
import * as filters from './filters';
import eventPlugin from './event';
import useCustomColumn from './table-custom-column';
import useCopy from './copy';

export const lib = {
  ...network,
  setPermission,
};

export default {
  install(application) {
    application.use(messagePlugin);
    application.use(directives);
    application.use(eventPlugin);
    application.config.globalProperties.op = op;
    application.provide('op', op);
    application.config.globalProperties.lib = lib;
    application.provide('lib', lib);
    application.config.globalProperties.filters = filters;
    application.provide('filters', filters);
    application.provide('useCustomColumn', useCustomColumn);
    application.provide('useCopy', useCopy);
    application.provide('useOffsetTop', (elm) => {
      if (!elm) {
        return 0;
      }
      let top = elm.offsetTop;
      let parent = elm.offsetParent;
      while (parent) {
        top += parent.offsetTop;
        parent = parent.offsetParent;
      }
      return top;
    });
  },
};
